<div class="nav-sidebar-container flex flex-row items-center">
    <a
    class="flex items-center nav-item button"
    [routerLink]="item().pagePath"
    routerLinkActive="active-button"
    ariaCurrentWhenActive="page"
    (mouseenter)="isHovered.set(true)"
    (mouseleave)="isHovered.set(false)"
    #rla="routerLinkActive">
        <app-icon-svg 
        width="24" 
        height="24" 
        [iconName]="item().iconName" 
        [color]="(isHovered() || rla.isActive) 
            ? '#242651'
            : '#fafafa'"
        ></app-icon-svg>
        {{ item().name }}
    </a>
</div>
